import React from 'react';

/**
 * Visible only in builds where REACT_APP_RELEASE_CHANNEL_BADGE=true is baked in
 * at build time (currently just the beta-prod branch env). Demo/QA aid to make
 * canary routing visually obvious - safe to remove once no longer needed.
 */
const ReleaseChannelBadge = () => {
  if (process.env.REACT_APP_RELEASE_CHANNEL_BADGE !== 'true') return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        textAlign: 'center',
        padding: '4px 0',
        backgroundColor: '#7c3aed',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.5px',
        pointerEvents: 'none',
      }}
    >
      BETA CHANNEL
    </div>
  );
};

export default ReleaseChannelBadge;
